import axiosInstance from '../../../config/axiosInstance';
const SaleOrderService = {
    async GetAllSaleOrder(redirectCallback, ClientCompanyID, Start, PageSize, searchQuery, sortColumn, sortDirection,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/SaleOrder/GetSaleOrder?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSaleOrderCount(redirectCallback, ClientCompanyID, searchQuery,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/SaleOrder/GetSaleOrderCount?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&searchQuery=${searchQuery}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllParts(redirectCallback, ClientCompanyID = 0) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAllParts?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSaleOrderType(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SaleOrder/GetSaleOrderTypes`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSaleOrderByID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SaleOrder/GetSaleOrderByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetSaleOrderItem(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SaleOrder/GetSaleOrderItem?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async DeleteSaleOrder(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/SaleOrder/DeleteSaleOrder?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async AllocateSaleOrder(formData) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.formData.UserID = UserID;
            const response = await axiosInstance.post(`/SaleOrder/AllocateSaleOrder`, formData);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetSaleOrderNo(ID, SaleOrderID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/SaleOrder/SetSaleOrderNo?ID=${ID}&SaleOrderID=${SaleOrderID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async ShipSaleOrder(SaleOrderID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/SaleOrder/ShipSaleOrder?SaleOrderID=${SaleOrderID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetSaleOrderItemHistory(redirectCallback, SaleOrderItemID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SaleOrder/SaleOrderItemsHistory?SaleOrderItemID=${SaleOrderItemID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async UnAllocateSaleOrder(SaleOrderID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/SaleOrder/UnAllocateSaleOrder?SaleOrderID=${SaleOrderID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async PaySaleOrder(SaleOrderID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/SaleOrder/PaySaleOrder?SaleOrderID=${SaleOrderID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async CustomerSaleOrderRecord(ClientCompanyID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/SaleOrder/CustomerSaleOrderRecord?ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LockSaleOrder(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/SaleOrder/LockSaleOrder?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockSaleOrder(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/SaleOrder/UnLockSaleOrder?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
     async SyncSaleOrderToFinancial(ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Customer/SyncCustomerToFinancialApp?ID=${idString}&ClientID=${ClientID}&UserID=${UserID}&action=SaleOrder`);
            if (response.data) {
                if (response.data.authUrl) {
                    // Open QuickBooks auth popup
                    const authPopup = window.open(
                        response.data.authUrl,
                        'QuickbookAuth',
                        'width=600,height=700,top=100,left=100'
                    );

                    if (!authPopup) {
                        throw new Error('Popup blocked. Please enable popups.');
                    }

                    // Polling to wait for user to close the popup
                    const interval = setInterval(() => {
                        if (authPopup.closed) {
                            clearInterval(interval);
                            console.log('Popup closed. Retrying QuickBooks customer creation...');
                            // Retry once popup is closed
                            //  this.QuickbookAddCustomer(ClientCompanyID);
                        }
                    }, 500);
                    return;
                } else {
                    // Success case
                    return response.data;
                }
            }

        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SaleOrderNonStockShipment(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/SaleOrder/SaleOrderNonStockShipment?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
     async CreateInvoiceFromSaleOrder(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SaleOrder/CreateInvoiceFromSaleOrder?ID=${ID}&UserID=${UserID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },

    
};

export default SaleOrderService;